var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccHotels(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8379",
    "data-name": "Rectangle 8379",
    width: 28,
    height: 28,
    transform: "translate(615 1839)",
    fill: "#f75f5f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8378",
    "data-name": "Rectangle 8378",
    width: 24.377,
    height: 21.768,
    transform: "translate(1.812 3.116)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hotels",
    transform: "translate(-615 -1839)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35225",
    "data-name": "Group 35225",
    transform: "translate(615.188 1838.884)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35224",
    "data-name": "Group 35224",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35871",
    "data-name": "Path 35871",
    d: "M23.056,12.745H4.847A3.049,3.049,0,0,0,1.812,15.78v8.126a.981.981,0,0,0,.979.979H3.966a.981.981,0,0,0,.979-.979V21.752H23.056v2.154a.981.981,0,0,0,.979.979h1.177a.981.981,0,0,0,.979-.979V15.78a3.2,3.2,0,0,0-3.133-3.035",
    fill: "#b3b5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35872",
    "data-name": "Path 35872",
    d: "M23.251,3.116H4.651A1.3,1.3,0,0,0,3.378,4.389v6.363H5.63V8.99A1.3,1.3,0,0,1,6.9,7.716H11.9a1.3,1.3,0,0,1,1.273,1.272v1.764h1.468V8.99a1.3,1.3,0,0,1,1.275-1.274H20.9a1.3,1.3,0,0,1,1.273,1.272v1.764h2.251V4.389a1.159,1.159,0,0,0-1.177-1.273",
    fill: "#b3b5c4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccHotels);
export default __webpack_public_path__ + "static/media/mcc_hotels.c0fd35ef8bbdee796fb1bc05d1284003.svg";
export { ForwardRef as ReactComponent };